import {
    creatAutoProgressor,
    type AutoProgressor,
} from "../../auto-progressor";
import s from "./style.module.css";
export interface Input {
    onScroll: () => void;
    onScrollEnd: () => void;
    count: number;
    debug?: boolean;
}
static type Timeout = ReturnType<typeof setTimeout> | null;
<const/{ count, onScroll, onScrollEnd, debug = false }=input>
<const/refs={
    currentIndex: 0,
    timeoutId: null as Timeout,
}>
<let/activeIndex=0>
<let/progressor=null as unknown as AutoProgressor>
<const/scrollTo(left: number, b: ScrollBehavior = "instant") {
    const scrollDriver = scrollDriverRef();
    scrollDriver.scrollTo({ left, behavior: b });
}>
<const/handleScrollEnd(resetPosition = true) {
    const scrollDriver = scrollDriverRef();
    const totalSlides = input.count;
    const slideWidth = scrollDriver.offsetWidth;
    const scrollPos = scrollDriver.scrollLeft;
    const slideIndex = Math.round(scrollPos / slideWidth);
    const totalDomSlides = totalSlides + 2;

    let newIndex = refs.currentIndex;

    if (slideIndex === 0) {
        if (resetPosition) scrollTo(totalSlides * slideWidth);
        newIndex = totalSlides - 1;
    } else if (slideIndex === totalDomSlides - 1) {
        if (resetPosition) scrollTo(slideWidth);
        newIndex = 0;
    } else {
        newIndex = slideIndex - 1;
    }

    // Commit changes on index change
    if (newIndex !== refs.currentIndex) {
        refs.currentIndex = newIndex;
        activeIndex = newIndex;
    }
}>

<div/scrollDriverRef
    class=s.scroller
    onScroll() {
        onScroll();

        if ("onscrollend" in window) return;

        if (refs.timeoutId) clearTimeout(refs.timeoutId);

        refs.timeoutId = setTimeout(() => {
            onScrollEnd();
            handleScrollEnd();
            progressor.reset();
            refs.timeoutId = null;
        }, 150);
    }
    onScrollEnd() {
        onScrollEnd();
        handleScrollEnd();
        progressor.reset();
    }
    onWheel() {
        progressor.reset();
    }
    onTouchStart() {
        progressor.reset();
    }
    tabindex=-1
    data-index=activeIndex>
    <div class=s.scrollTrack>
        <for|i| from=0 until=count + 2>
            <div class=s.scrollItem data-debug=`${debug}`>
                <if=debug>
                    ${i + 1}
                </if>
            </div>
        </for>
    </div>
</div>

<script>
    const autoProgressor = creatAutoProgressor(() => {
        const el = scrollDriverRef();
        const itemWidth = el.clientWidth;
        el.scrollBy({
            left: itemWidth,
            behavior: "smooth",
        });
    });
    progressor = autoProgressor;
    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
        if (isIntersecting) autoProgressor.start();
        else autoProgressor.stop();
    });
    observer.observe(scrollDriverRef());
    $signal.onabort = () => {
        observer.unobserve(scrollDriverRef());
        observer.disconnect();
        autoProgressor.stop();
    };
</script>
<script>
    let resizeTimeout: ReturnType<typeof setTimeout>;
    let previousWidth = window.innerWidth;
    window.addEventListener(
        "resize",
        () => {
            const currentWidth = window.innerWidth;
            if (currentWidth === previousWidth) return;
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Hack to prevent
                const currentIndex = parseFloat(
                    scrollDriverRef().dataset.index ?? "0",
                );
                // Maintain position after resize
                const slideWidth = scrollDriverRef().offsetWidth;
                scrollDriverRef().style.scrollBehavior = "auto";
                scrollDriverRef().scrollLeft = (currentIndex + 1) * slideWidth;
                scrollDriverRef().style.scrollBehavior = "";
            }, 100);
            previousWidth = currentWidth;
        },
        {
            signal: $signal,
        },
    );
</script>
<script>
    if ("onscrollsnapchanging" in window) {
        scrollDriverRef().addEventListener(
            "scrollsnapchanging",
            () => {
                onScrollEnd();
                handleScrollEnd(false);
            },
            {
                signal: $signal,
            },
        );
    }
    scrollDriverRef().scrollLeft = scrollDriverRef().offsetWidth;
</script>
